export default [
  {
    title: 'สถานที่ใกล้เคียง',
    icon: 'ShoppingBagIcon',
    tagVariant: 'light-warning',
    resource: 'Place',
    action: 'read',
    children: [
      {
        title: 'Lists',
        route: 'poi-list',
        resource: 'Place',
        action: 'read',
      },
      {
        title: 'Add',
        route: 'poi-create',
        resource: 'Place',
        action: 'create',
      },
    ],
  },
]
